import { createApp, h, resolveComponent } from 'vue'

import { store } from '@/store'
import { getPluginOptions } from '@jira/app'
import AppAuth from '@jira/layout/AppAuth'
import { APP_PLATFORMS } from '@root/app-platforms'
import { CONFLUENCE_APP_PLUGIN_OPTIONS } from '@root/template-options-keys'

const createConfluenceApp = (component, rootElement, additionalProps) => {
  const { refreshToken, accessToken, pluginType, ...rest } = getPluginOptions(
    CONFLUENCE_APP_PLUGIN_OPTIONS,
    rootElement
  )

  const app = createApp({
    name: 'AppAuthWrapper',
    components: {
      AppAuth,
      'main-component': component
    },

    // use AppAuth as layout(root component) for all entry-points
    render: () =>
      h(
        resolveComponent('AppAuth'),
        {
          accessToken,
          refreshToken,
          pluginType,
          pluginOptions: {
            pluginType,
            ...rest
          },
          appPlatform: APP_PLATFORMS.JIRA
        },
        {
          default: props => h(resolveComponent('main-component'), { ...props, ...additionalProps })
        }
      )
  })

  app.use(store)

  store.dispatch('appContext/setIsConfluenceApp')

  return app
}

export const createAuthApp = (...args) => createConfluenceApp(...args)
